export default __webpack_public_path__ + "static/media/ia_white_logo_w_text.29278cb7.png";